import * as React from "react";
import "./style.css";

export const ButtonV2 = ({ classname = "", action, text }) => (
  <button type="button" className={`${classname} customButtonV2`.trim()} onClick={action}>
    {text}
  </button>
);
